import { noop } from 'es-toolkit';
import type { StorageEngine } from './storageEngine';
import { isServer } from '../function';

const clientLocalStorageEngine: StorageEngine = {
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),
};

const serverStorageEngine: StorageEngine = {
  getItem: () => null,
  setItem: noop,
  removeItem: noop,
};

export const localStorageEngine = isServer() ? serverStorageEngine : clientLocalStorageEngine;
